import { KpiSetupState } from "../components/kpi/setup/KpiSetup";
import React from "react";
import { SelectProps, TextFieldProps } from "@mui/material";
import {IconDefinition, IconProp} from "@fortawesome/fontawesome-svg-core";
import { XYPosition } from "reactflow";
import { authConfigurationValuesTypes, configurationAttributeType, helpdeskConfigurationValuesTypes } from "../types";
import { updateConfigRequestBody } from "../services/managePoliciesService";
import { DownloadItem } from "../features/reports/types/types";
//import { type } from "os";

export enum ApprovalStatus {
  INITIATE,
  PENDING,
  APPROVED,
  REJECTED
}

export type KpiStatus = {
  contents: KpiWithSchedulerInfo[];
  activeKpis: number;
  totalKpis: number;
  inactiveKpis: number;
  success: number;
  failure: number;
};

export type KpiWithSchedulerInfo = {
    kpiInfo: KpiInfo,
    schedulerInfo: SchedulerInfo,
    isSelected: boolean
}

export type KpiQuery = {
    name: string,
    query: string
}
export type Query = {
    name: string,
    query: string
}
export type KpiInfo = {
    id?: string,
    name: string,
    description: string,
    extendedAttributes: {
        documentation: string,
        refreshMode: 'SOFT' | 'HARD'
    },
    owner: string,
    createdBy: string,
    activeStatus: string,
    target: 'OUTLET' | 'USER',
    targetFilter: string,
    aggregationNames: string[],
    cron: string,
    timezone: string,
    implementation: string,
    statusEvaluator: string,
    executionMode: 'SPLIT' | 'BATCH',
    batchSize: number,
    configuration: {
        queries: KpiQuery[]
    }
    extractorType: 'SQL'
}

export type uploadDocumentType = {
    body: string
    header: any
    statusCodeValue: number
    statusCode: string
}

export type submitUserAccountType = {}

export type SchedulerInfo = {
  name: string;
  nextScheduledTime: string;
  lastModifiedTime: string;
  lastRunTime: string;
  extendedAttributes?: {
    status: "SUCCESS" | "FAILURE";
  };
};

export type User = {
  lob: string;
  activeStatus: string;
  userAccountId: string;
  loginId: string;
  email: string;
  mobile: string;
  roles: [];
  immediateParent: string;
  supplierMetaData: [];
  designation: [];
  name: string;
  dialCode: string;
  verified: boolean;
  blocked: boolean;
};

export type AuthContextType = {
    user: User,
    env: string,
    token: string
}
export interface AuthConfigType extends ApplicationInfo {
    baseUrl: string
}
export interface ApplicationInfo{
    SERVER_URL: string
    publicKey: string
    endToEndEncryptionEnabled: boolean
}

export type AggregationInfo = {
  aggregationName: string;
  description: string;
};
export type PrefillInfo = {
aggregationName: string;
  description: string;
};

export type Division = {
  divisionName: string;
  displayName: string;
  id: string;
};

export interface SqlQueryProps {
  index: number;
  key: number;
  props: any;
}

export interface sqlQueryData {
  queryName: string;
  query: string;
}

export interface CommonComponentState {
  loading: boolean;
  error?: string;
}

export type KpiProps = {
    validationErrors: ValidationError[],
    kpiInfo: KpiInfo,
    setKpiInfo: (info: KpiInfo) => void
    setKpiState: React.Dispatch<React.SetStateAction<KpiSetupState>>
}
export type ReportQuery = {
    name: string,
    query: string
}
export type ReportInfo = {
    id: string,
    name: string,
    description: string,
    type?:string,
    implementation: string,
    fetchLimit: number,
    fileFormat?:string,
    fileNameFormat?:string,
    extendedAttributes:{
        documentation?: string,
        refreshMode?: 'SOFT' | 'HARD',
        headers?: any
    },
    transformer:string;
    createdBy: string,
    activeStatus: string,
    target: 'OUTLET' | 'USER',
    targetFilter: string,
    timezone: string,
    reportDefenition: string,
    statusEvaluator: string,
    executionMode: 'SPLIT' | 'BATCH',
    batchSize: number,
    owner:string,
    reviewer:string,
    reviewStatus:'PENDING' | 'APPROVED',
    viewEditStatus?: 'VIEW' | 'EDIT',
    reviewingStatus?: 'NONE' | 'REVIEW',
    configuration: {
        queries: ReportQuery[]
    }
    extractorType: 'SQL'
}
export type ReportSetupState = {
    reportInfo: ReportInfo,
    loading: boolean,
    error?: string,
    validationErrors: ValidationError[]
}

export type QueryInfo= {
    id: string,
    name: string,
    query:string,
    language: string,
    implementation:string,
    type:string,
    description:string,
    enabled:boolean,
    params?:object,
    UIParams?:object[],
    queryInfoBody?:object,
    extendedAttributes?:object,
    data?:object[],
    owner:string,
    reviewer:string,
    reviewStatus:'PENDING' | 'APPROVED',
}
export type requestBodyType={
    requestBody: object
}
export type ReportInfoDTO = {
    reportInfo: ReportInfo,
    queryInfo: QueryInfo,
    reportUI: ReportUI
}

// export type RequestBodyState = {
    
//     lob: string,
//   changes: any[],
//   extendedAttributes: {headers: any},
//   name: string,
//   type: string,
//   implementation: string,
//   fetchLimit: number,
//   reportDelimiter: string,
//   create: boolean,
    
// }

export type ReportQueryProps = {
    query:Query,
    setQuery: (query: Query) => void
    queryInfo:QueryInfo,
    viewReportFlag:boolean,
    setViewReportFlag: React.Dispatch<React.SetStateAction<boolean>>,
    setQueryInfo:(queryInfo:QueryInfo) => void
    queryInfoViewReport:QueryInfo,
    setQueryInfoViewReport:(queryInfo:QueryInfo) => void
    setReportState: React.Dispatch<React.SetStateAction<ReportSetupState>>
}
export type ReportComponentName ='downloadReport' | 'viewReport'

export type ReportProps = {
    validationErrors: ValidationError[],
    reportInfo: ReportInfo,
    query:Query,
    setQuery: (query: Query) => void
    queryInfo:QueryInfo,
    viewReportFlag:boolean,
    setViewReportFlag: React.Dispatch<React.SetStateAction<boolean>>,
    diffrentQueryForViewReportFlag:string,
    setDiffrentQueryForViewReportFlag: React.Dispatch<React.SetStateAction<string>>,
    setQueryInfo:(queryInfo:QueryInfo) => void
    queryInfoViewReport:QueryInfo,
    setQueryInfoViewReport:(queryInfo:QueryInfo) => void
    setReportInfo: (info: ReportInfo) => void
    setReportState: React.Dispatch<React.SetStateAction<ReportSetupState>>
    alertContent:string,
    showDraggableList: boolean,
    setShowDraggableList: React.Dispatch<React.SetStateAction<boolean>>,
    valueReportType: string,
    setValueReportType: React.Dispatch<React.SetStateAction<string>>,
    showInput: boolean,
    setShowInput: React.Dispatch<React.SetStateAction<boolean>>,
    columns: any,
    setColumns: React.Dispatch<any>,
    columnsViewReport: any,
    setColumnsViewReport: React.Dispatch<any>,
    showInputAddQueryColumn: boolean,
    setShowInputAddQueryColumn: React.Dispatch<React.SetStateAction<boolean>>,
    valueAddQueryColumn: string,
    setValueAddQueryColumn: React.Dispatch<React.SetStateAction<string>>
    showHide:boolean,
    queryFlag: QueryFlag,
    setQueryFlag: React.Dispatch<React.SetStateAction<QueryFlag>>,
    reportUI: ReportUI,
    setReportUI: (reportUI: ReportUI) => void,
    showReport: boolean,
    setShowReport: (reportUI: boolean) => void,
    currentReportComponent:ReportComponentName,
    setCurrentReportComponent:(currentReportComponent:ReportComponentName)=>void,
    extendedAttributesViewReports: any,
    setExtendedAttributesViewReports: React.Dispatch<any>
    setReportUIState: React.Dispatch<React.SetStateAction<ReportUISetupState>>
    
}
export type ReportUISetupState = {
    reportUI: ReportUI,
    loading: boolean,
    error?: string,
    validationErrors: ValidationError[]
}
export interface ReportUI {
    role: string,
    type: string,
    label: string,
    filter: string,
    globalFilter: Filter
}
export interface Filter {
    allFilter: GlobalFilter,
    globalFilter: GlobalFilter,
    selectedFilter: SelectedFilter,
    columns: columnsBodyObject[];
}

export interface GlobalFilter {
    list: string[];
}
export interface SelectedFilter {
    list: SelectedFilterItem[];
}
export interface SelectedFilterItem {
    id: string,
    parent: string,
    multiSelect: boolean;
}

export interface SqlModalProps {
  openModal: boolean;
  setOpenModal: React.Dispatch<React.SetStateAction<boolean>>;
  forceUpdate?: any;
  props?: KpiProps;
  query?: string;
  edit?: boolean;
  queryName?: string;
}


export interface SqlEditorProp extends KpiQuery {
    props: KpiProps;
    forceUpdate: any;
    closeModal: () => void;
    setSqlEditorOpened: React.Dispatch<React.SetStateAction<boolean>>;
    setSqlRunnerOpened: React.Dispatch<React.SetStateAction<boolean>>;
    setSqlQuery: React.Dispatch<React.SetStateAction<string>>;
    edit: boolean
}

export interface QueryRunnerProp extends KpiQuery {
    executionMode: string;
    closeModal: () => void;
    setSqlEditorOpened: React.Dispatch<React.SetStateAction<boolean>>;
    setSqlRunnerOpened: React.Dispatch<React.SetStateAction<boolean>>;
}

export interface queryExecutorInput {
    loginId?: string;
    loginIds?: string[];
}

export interface queryExecutorRequestBody {
    configuration: {
        queries: KpiQuery[]
    }
    executionMode: string
    loginId?: string
    loginIds?: string[]
}

export interface scriptExecutorRequestBody {
    configuration: {
        queries: KpiQuery[]
    }
    executionMode: string
    statusEvaluator: string
    loginId?: string
    loginIds?: string[]
}

export interface queryExecutorResponse {

}

export interface scriptExecutorResponse {

}
export interface queryExecutorResponse {}

export interface scriptExecutorResponse {}

export interface KpiFilterState extends CommonComponentState {
  designations: SelectableItem<Division>[];
  activeStatus: SelectableItem<string>[];
  users: SelectableItem<string>[];
  refreshTypes: SelectableItem<string>[];
  userTypes: SelectableItem<string>[];
}

export type SelectableItem<T> = {
  item: T;
  isSelected: boolean;
};

export interface QueryCardProp extends KpiQuery {
    sqlQueryArr: KpiQuery[];
    forceUpdate: any;
    props: KpiProps
    plus: boolean;
    openSqlTextEditor: () => void;
    isNoQuery: boolean
}

export interface ConfirmPopUpProps {
    message: string,
    buttonPlaceHolder: string;
    openConfirmModal: boolean;
    setOpenConfirmModal: React.Dispatch<React.SetStateAction<boolean>>;
    deleteQueryCard: () => void;
}

export interface ConfirmPopUpProps {
  message: string;
  buttonPlaceHolder: string;
  openConfirmModal: boolean;
  setOpenConfirmModal: React.Dispatch<React.SetStateAction<boolean>>;
}

export class ValidationError {
  message: string;

  property: string;

  constructor(property: string, message: string) {
    this.property = property;
    this.message = message;
  }
}

export type Validator<T> = {
  validate: (item: T) => ValidationError[];
};

type ScriptModalOpenProps = {
    opened: boolean,
    setOpened: (flag: boolean) => void
}
export type ScriptModalProps = KpiProps & ScriptModalOpenProps & { value: string }
export type ScriptEditorProps = ScriptModalProps & {
    closeModal: () => void;
    setScriptEditorOpened: React.Dispatch<React.SetStateAction<boolean>>;
    setScriptExecutorOpened: React.Dispatch<React.SetStateAction<boolean>>;
    setScript: React.Dispatch<React.SetStateAction<string>>;
}

export interface ScriptExecutorProps {
    script: string;
    configuration: {
        queries: KpiQuery[]
    };
    executionMode: string;
    closeModal: () => void;
    setScriptEditorOpened: React.Dispatch<React.SetStateAction<boolean>>;
    setScriptExecutorOpened: React.Dispatch<React.SetStateAction<boolean>>;
}

export interface ConfirmationPopUpProps {
    message: string,
    openConfirmModal: boolean;
    setOpenConfirmModal: React.Dispatch<React.SetStateAction<boolean>>;
    successMethod: any;
    rejectMethod?: any;
    confirmationCustomComponent?: React.ReactNode;
    rightButtonText?:string | null
}

export interface GenericPopUpProps {
    type: popupType
    message: string,
    openGenericModal: boolean;
    themeColor?:string;
    setOpenGenericModal: React.Dispatch<React.SetStateAction<boolean>>;
    onCloseCallback?: () => void;
}

export interface downloadLoader{
    message: string,
    openReportModal:boolean;
    setOpenReportModal:React.Dispatch<React.SetStateAction<boolean>>;
}
export interface downloadBar{
  downloadCount:number
  downloads:DownloadItem[],
  isPasswordSet:boolean,
}
export interface downloadBarIcon{
  isPasswordSet:boolean,
}

export type popupType = "Alert" | "Success" | "Error";

export interface QueryViewProps {
    openedQueries: boolean
    setOpenedQueries: React.Dispatch<React.SetStateAction<boolean>>;
    queryList: KpiQuery[]
}

export interface ScriptViewProps {
    openedScript: boolean
    setOpenedScript: React.Dispatch<React.SetStateAction<boolean>>;
    script: string
}

export type createAccountFormValidation = {
  nameOfAccountHolder: accountFieldValidation,
  bankName: accountFieldValidation,
  bankAccountNumber: accountFieldValidation,
  confirmBankAccountNumber: accountFieldValidation,
  ifsc: accountFieldValidation,
  pinCode: accountFieldValidation,
  addressLine1: accountFieldValidation,
  addressLine2: accountFieldValidation,
  email: accountFieldValidation,
  mobile: accountFieldValidation,
  constitution: accountFieldValidation,
  contactName: accountFieldValidation,
  authPersonName: accountFieldValidation,
  pan: accountFieldValidation,
  gstin: accountFieldValidation,
  checkLeafURL: accountFieldValidation,
  authorizationLetter: accountFieldValidation
}
type accountFieldValidation = {
  isValidated: boolean;
  message: string;
};
export type createAccountInput = {
  nameOfAccountHolder: string,
  bankName: string,
  bankAccountNumber: string,
  confirmBankAccountNumber: string,
  ifsc: string,
  pinCode: string,
  addressLine1: string,
  addressLine2: string,
  email: string,
  mobile: string,
  constitution: string,
  contactName: string,
  authPersonName: string,
  pan: string,
  gstin: string,
  checkLeafURL: string,
  authorizationLetter: string
}


export type OtherInformationProps = {
  handleChange: (event: any) => void,
  formValidation: createAccountFormValidation,
  inputs: createAccountInput,
  setFormValidation: React.Dispatch<React.SetStateAction<createAccountFormValidation>>,
  hiddenFileInput: React.MutableRefObject<HTMLInputElement>,
  hiddenLetterInput: React.MutableRefObject<HTMLInputElement>,
  handleFileClick: (event: any) => void,
  handleLetterClick: (event: any) => void,
  submitForm: () => void,
  selectedFile: string,
  selectedFileLetter: string,
  handleFileChange: (event: any) => void,
  handleLetterChange: (event: any) => void,
  handleChangeDropDown: (selected: string, name: string) => void
  dropDownValue: any,
  setDropDownValue: any
  declaration:{text:string , accepted:boolean};
  setDeclaration: React.Dispatch<React.SetStateAction<{
    text: string;
    accepted: boolean;
}>>
declarationTextLoading:boolean,
adminApproval:ApprovalStatus,
fileUploaded: Blob | undefined,
letterUploaded: Blob | undefined,
comment: string,
disableInputs : boolean,
blobKey: string,
blobKeyLetter: string
}


export type AddressInformationProps = {
    handleChange: (event: any) => void,
    formValidation: createAccountFormValidation,
    inputs: createAccountInput,
    setFormValidation: React.Dispatch<React.SetStateAction<createAccountFormValidation>>,
    submitForm: () => void,
}

export type BasicInformationProps = {
  handleChange: (event: any) => void,
  formValidation: createAccountFormValidation,
  inputs: createAccountInput,
  setFormValidation: React.Dispatch<React.SetStateAction<createAccountFormValidation>>,
  submitForm: () => void,
  handleChangeDropDownBankName: (selected: string, name: string) => void,
  successfullySubmitted: boolean,
  // updatePageInputs?: () => void
  testClick: () => void,
  loginid?: any,
  disableInputs : boolean,
  adminApproval:ApprovalStatus,
}

export type CreateAccountValidatorProps = {
    setFormValidation: React.Dispatch<React.SetStateAction<createAccountFormValidation>>,
    formValidation: createAccountFormValidation,
    openPopup: (message: string, type: popupType) => void
}


export type bankListType = {
  id: string;
  name: string;
  image: string;
  checked: boolean;
  disabled?: boolean;
};

export type heading = {
  mainHeading?: String;
  subHeading?: String;
};

export type paymentMethodTilesProps = {
  id: string;
  name: string;
  image: string;
  disabled?: boolean;
  checkedRetailers?: string;
  setCheckedRetailers?: React.Dispatch<React.SetStateAction<string>>;
  checkRetailerSharingDetails?: string;
  setCheckRetailerSharingDetails?: React.Dispatch<React.SetStateAction<string>>;
  isDivDisabled?: boolean
};

export type paymentMethodTilesAdminProps = {
    id: string,
    name: string,
    image: string,
    disabled?: boolean,
    metaDataBankList?: any,
    setMetaData: React.Dispatch<any>
}

export type userAccountDetailsType = {
  loginId: any;
  accountInfo: {
    loginId: any;
    accountNumber: string;
    ifsc: string;
    authPersonName: string;
    email: string;
    mobile: string,
    contactName: string;
    pan: string;
    gstin: string;
    checkLeafURL: string;
    addressLine1: string;
    addressLine2: string;
    constitution: string;
    bankName: string;
    extendedAttributes: {
      pincode: string;
      authorizationLetter: string;
  };
  };
};

export type extendedAttributesType =  {
  loginId?: any;
  accountHolderName: string,
  accountNumber: string;
  ifsc: string;
  authPersonName: string;
  email: string;
  mobile: string,
  contactName: string;
  pan: string;
  gstin: string;
  checkLeafURL: string;
  addressLine1: string;
  addressLine2: string;
  constitution: string;
  bankName: string;
  pincode:string;
  authorizationLetter: string;
  extraAttributes?: string;
};

export type requestBodyForAdminApprovalType = {
  loginId: any;
  status: string;
  accountInfo: {
    loginId: any;
    accountNumber: string;
    ifsc: string;
    authPersonName: string;
    email: string;
    mobile: string,
    contactName: string;
    pan: string;
    gstin: string;
    checkLeafURL: string;
    addressLine1: string;
    addressLine2: string;
    constitution: string;
    bankName: string;
    extendedAttributes: {
      pincode: string;
      authorizationLetter: string;
  };
  };
}

export type outletListAPiResponse = {
    features: outletList[]
}

export type outletListAPiResponsePaymentBlock = {
  features: outletListPaymentBlock[]
}

export type outletList = {
  id: string;
  district: string;
  branch: string;
  outletcode: string;
  outlet_name: string;
};

export type outletListPaymentBlock = {
  login_id: string;
  outlet_name: string;
  type: string;
};

export type PaymentBankProps = {
  bankName: string;
  image: string;
  id: string;
};

export type tableDataProps = {
    banks: PaymentBankProps[],
    dat: outletList,
    submitForm: (bankSelected: string[], outletcode: string, id: string) => Promise<void>,
    bankNameSuccess: creditStatusType[];
}

export type tableDataPropsPaymentBlock = {
  dat: outletListPaymentBlock,
  submitForm: (paymentStatus: any, login_id: string, type: string) => Promise<void>,
  paymentBlocked: paymentBlockType[];
}


export type connectionType = {
  providerType : string
  image: string;
  name: string;
  attributes: any[];
};

export type connectionTypeProps={
    providerType : string,
    image: string,
    name: string,
    active: boolean,
    onClick: any,
}

export type IntegrationEntity = {
    entityName: string;
};

export type RemoteFileInfo = {
    name: string;
    profile: string;
    size: number;
    lastmodified: number;
}

export type IntegrationSchedule = {
    fileName:string,
    transformerId:string,
    outProfileName:string,
    passKey:string,
    status:string,
    env:string,
    jobName:string,
    skipCols:string,
    entityFileNameMapping:string,
    entityName:string,
    mapper:string,
    profileName:string,
    startsWith:string,
    encoding:string,
    mapperName:string,
    skipPreProcess:string,
    delimiter:string,
    lob:string,
    frequency?:string,
    headers?:string,
    streamType?:string,
}
export type connectionProfileType = {
    id? : string;
    name: string;
    type: string;
    attributes: any;
    payload?: string;
    lob: string;
    active? : boolean,
};
export type creditStatusType = {
    userId: string;
    supplier: any;
    isEnabled: string;
    paymentEnabled: string;
    paymentProvideType: string;
}

export type paymentBlockType = {
  paymentBlock : string;
  login_id: string;
  type: string;
}

export type sideMenuButtonsProps = {
    icon: IconProp
    buttonName: string,
    href: string,
    hrefClassName: string,
    svgClassName: string,
    otherSvg?: React.ReactNode
    isActive: boolean
}

export interface ColumnProps {
    col: {
      id: string
      list: string[]
    },
    columns: any,
    setColumns: React.Dispatch<any>
  }

  export type sourceProps = { 
    droppableId : string,
    index : number
  }

  export interface ItemProps {
    text: string
    index: number
    id: string,
    columns: any,
      setColumns: React.Dispatch<any>
  }
    


export type IntegrationFileInfo = {
  fileName: string;
  size:string;
  lastmodified:string;
  entityName:string;
  jobid: string;
  fileURL: string;
  headers: string;
  firstRecord: string;
  recordCount: number;
  lob:string;
  ig: IntegrationFileStats[];
};

export type RemoteStreamLoadFile = {
  fileName: string;
  name: string;
  profile: string;
  size: string;
  lastmodified: string;
  startsWith: string;
  delimiter: string;
  encoding: string;
  entityName: string;
  profileName: string;
  mapperName: string | null;
  lob:string;
  passKey:string;
};

export type IntegrationFileStats = {
  total: string | number | null;
  success: string | number | null;
  entityName: string | null;
  groupId: string | null;
  failure: string | number | null;
  serverFailure: string | number | null;
};

export type requestObjMetaData = {
    isEnabled: string,
    paymentServiceProvider: string
}

export type orderTile = {
  fetchFromSaleslens?:any,
    heading:string,
    subHeading:string,
    footerHeading:string,
    img:IconDefinition | string,
    api?:string,
    api2?:string,
    callApi?:boolean,
    orderPrimaryValue?:string,
    orderSecondaryValue?:string,
    visible?:boolean
}

export type orderStatusConfig = {
  id:string;
  label?: string;
  dmsLabelColor?: string;
  dmsLabel?: string;
  dmsColor?: string;
}

export type orderSourceConfig = {
  id:string;
  gradientColor?: string;
  textColor?: string;
}

export type loadoutStatusConfig = {
  id:string;
  dmsLabelColor?: string;
  dmsLabel?: string;
  dmsColor?: string;
}

export type grnStatusConfig = {
  id:string;
  dmsLabelColor?: string;
  dmsLabel?: string;
  dmsColor?: string;
}

export type analyticsTile = {
  heading:string,
  status:string,
 

}

export type userTile = {
    heading:string,
    subHeading:string,
    footerHeading:string,
    img:string,
    api:string,
    api2:string

}

export type OrderChartTrends = {
 api:string
 api2:string
}

export type UserChartTrends = {
    api:string
    api2:string
    chart?:Record<string, any>
   }

export type tableData = {
    // api:string
    
}

export type userTableData={
    api:string
    api2:string
    api3:string
}

export type tableDateCate = {
    api:string
    api2:string
    
}

export type tableHeading = {
    heading:string
}

export type inputType={
    key: string,
    value: string
}

export type IntegrationMapper={
  id:string;
  mapperName:string;
  type: "db" | "dynamo";
  config: string|object;  
  entityName:string;
  implementation?:string;
}

export type SalesMapper={
  columnName:string,
  mappedColumn:string|null,
  formatter:string|null,
  transFunction:'none'
}

export type SalesMapperRequest={
  mapper:string,
  name:string | null | undefined,
  type:string,
  lob:string,
}

export type SalesMapperFieldConfig={
  columnName: string;
  displayName: string;
  formatter: boolean;
  isRequired: boolean;
}

export type configComparatorType = {
  configId: string;
  configName: string;
  description: string;
  activeStatus : string;
  cmpDiff: Map<string, boolean>;
  diff: Map<string, JSON>;
};

export class ConfigComparator implements configComparatorType {
  constructor(public configId: string, public configName: string, 
    public description: string, public activeStatus: string, public cmpDiff: Map<string, boolean>, public diff: Map<string, JSON>) {}
  toString(){
    let diffJson = {}, compDiffJson = {};
    Array.from(this.cmpDiff.entries()).forEach((s: [string, boolean]) => Object.assign(compDiffJson, { [s[0]]: s[1] }));
    Array.from(this.diff.entries()).forEach((s: [string, JSON]) => Object.assign(diffJson, { [s[0]]: s[1] }));
    return {
      configId: this.configId,
      configName: this.configName,
      description: this.description,
      activeStatus: this.activeStatus,
      cmpDiff: compDiffJson,
      diff: diffJson
    }
  }
}


export type LoginResponse = {
  token: string;
  user: any;
};

export interface LoginData {
  loginId: string;
  password: string;
  lob?: string;
  deviceId?: string;
  secureToken?: string;
  unlimitedExpiry?: boolean;
}

export type SummaryAttributesType = {
  required: boolean;
  name: string;
  displayName: string;
  value?: string;
  defaultValue?: string;
  visibility?: boolean;
  options?: string[];
  dependsOn?: {
    fieldName: string;
    value: string;
  };
}

export type FileFilterPageInfo = {
  passKey:string
  entityName:string
  startsWith:string
  encoding:string
  delimiter:string
}
export type mediaType = {
  type : string,
  attributes : any,
  displayName : string
}

export type fieldInfoMap = {
  name : string,
  datatype : string,
  typeClass : string,
  isPrimitive : boolean,
  declaringClass : string,
  isChannelkart : boolean,
  jsonIgnore : boolean,
  notNull : boolean,
  isMandatory : boolean,
  genericType : string,
  isCollection : boolean
}

export type parameterInfo = {
  type : string,
  required : boolean,
  parameterName : string,
  isVariableArgument : boolean,
  parameterDescription : string
} 

export type functionMap = {
  id : string,
  language?: string;
  description?: string;
  returnType?: string;
  implementation?: string;
  parametersInfo : parameterInfo[],
  functionBody ?: string
}

export type conversionType = {

  functionName : string|null,
  unRegisteredFunction : string|null
  constInput : {
    [key:string]:string[]
  },
  recordInput : {
    [key:string]:string[]
  }
}

export type mappingObject = {
  from : string[],
  to : string,
  conversions : conversionType[]
}

export type integrationSummary = {
  startTime : string,
  stats : string,
  endTime : string,
  timestamp : string,
  refName : string,
  dumpFileKey : string
}

export type historicalSummary = {
  group_Id : string,
  taskDate : string,
  groupItems : string,
  status: string
}

export type historicalDataOverAllSyncSummary = {
  tableWise: {
  group_Id : string,
  taskDate : string,
  groupItems : string,
  status: string
}[],
  overAllStatus: {
    mysqlTotal: number;
    redshiftTotal: number;
    s3Total: number;
    mysqlDifference: number;
    s3Difference: number;
    group_Id: string;
    taskDate: string;
  }[]
}

export type historicalDataLiveStatusSummary = {
  tableWise: {
    taskDate: string;
    groupItems: string; 
  }[];
  liveStatus: {
    tableName: string;
    totalRecordCount: number;
    lastSyncDateTime: string;
    lastSyncStatus: string;
    lastSyncRecordCount: number;
  }[];
};



export type integrationStats = {
  lob : string,
  groupId : string | null,
  total : number,
  success : number,
  serverFailure : number,
  entityName : string,
  failure : number
}
export type historicalStats = {
  lob : string,
  table_name : string | null,
  totalexternalrecords : number,
  totalredshiftrecords : number,
  successdelete : number,
  faileddelete : number,
  totalmissing: number,
  status:string,
  notfoundfilepath:string,
  failedtodeletepath:string,
  startdate:string,
  enddate:string
  
}

export type IntegrationJobstats = {
  stats: string;
  status: string;
  headers: string;
  firstRecord: string;
  startTime: number;
  mapper: string;
  endTime: number;
  fileId: string;
  mapperName: string;
  fileURL: string;
  lob: string;
  extraParams: string;
};

export type RootEntitySplitKeyOptions = {
  id:string
  config:string
  header:string
  description:string
  description2:string
}
export type RootEntitySplitKeysMetadata = {
  "data":RootEntitySplitKeyOptions[];
  "name":string;
  "header":string;
  "description":string;
  "domain-name":string;
  "domain-type":string;
}
export type SplitKeyConfig = {
  domainName:string
  domainType:string
  domainValues : []
}

export type TransformerInfo = {
  code : mappingObject[];
  id:string;
  name:string;
  enabled:boolean
  language:string;
  implementation:string;
  version:number|string;
  type:string;
}
export interface initialColumns {
    Query_Columns: QueryColumns
    Report_Columns: ReportColumns
  }
  
  export interface QueryColumns {
    id: string
    list: string[]
  }
  
  export interface ReportColumns {
    id: string
    list: string[]
  }
export type dashboardSelectProps={
    label?:string,
    selectLableId:string,
    options?:any[];
    disabled?:boolean;
} & SelectProps

export type InputListProps={
    configName:string
    question?:string
    values:any ,
    setValues: any
} & TextFieldProps

export type configObj = {
    featureName: string;
    featureDesc: string;
}
export type tooltipDescType = {
    [key: string]: configObj[]
}
export type catalogueValueTypes={
  [key:string]: configurationAttributeType<any>,
  maxAllowedDigitForOrder:configurationAttributeType<number>,
  pieceSizeLabel:configurationAttributeType<string>,
  dummyItemCouponImage:configurationAttributeType<string>,
  dummyCouponImage:configurationAttributeType<string>,
  caseToPieceLabel:configurationAttributeType<string>,
  catalogueSortingType:configurationAttributeType<string>,
  ptrVisibility:configurationAttributeType<string>,
  unnatiCatalogueSorting:configurationAttributeType<boolean>,
  couponFilterVisibility:configurationAttributeType<boolean>,
  showScanButton:configurationAttributeType<boolean>,
  caseToPieceVisibility:configurationAttributeType<boolean>,
  bundleCouponVisibility:configurationAttributeType<boolean>,
  orderCheckoutPtrLabel:configurationAttributeType<string>,
  skuCodeCondition:configurationAttributeType<string>,
  favouriteSKU:configurationAttributeType<boolean>,
  showFreeProductLabel:configurationAttributeType<boolean>,
  skuDescriptionFormatter:configurationAttributeType<string>,
  skuCodeVisibility:configurationAttributeType<boolean>,
  ptrLabel:configurationAttributeType<string>,
  mrpLabel:configurationAttributeType<string>,
  schemeLabel:configurationAttributeType<string>,
  multiVariantHeader:configurationAttributeType<string>,
  unitLabel:configurationAttributeType<string>,
  unitVisibility:configurationAttributeType<boolean>,
  autoUOMConversion:configurationAttributeType<boolean>,
  multiUOMSelection:configurationAttributeType<boolean>,
  packUnitLabel:configurationAttributeType<string>,
  caseUnitLabel:configurationAttributeType<string>,
  otherUnitLabel:configurationAttributeType<string>,
  otherPtrLabel:configurationAttributeType<string>,
  dummyProductImgUpload:configurationAttributeType<string>,
  incentiveFlow:configurationAttributeType<boolean>,
  showBilledSkuLabel:configurationAttributeType<boolean>,
  displayPrice:configurationAttributeType<boolean>,
  schemeVisibility:configurationAttributeType<boolean>,
  additionalSchemes:configurationAttributeType<boolean>,
  crossSellLabel:configurationAttributeType<string>,
  similarProductLabel:configurationAttributeType<string>,
  upSellLabel:configurationAttributeType<string>,
  orderUnit:configurationAttributeType<string>,
  multiVariantSortingOption:configurationAttributeType<string>,
  multiVariantGroupingOption:configurationAttributeType<string>,
  casePtrLabel:configurationAttributeType<string>,
  packPtrLabel:configurationAttributeType<string>,
  orderSuggestedQty:configurationAttributeType<boolean>,
  defaultCatalogueImage:configurationAttributeType<string|undefined>,
  missedSchemeVisibility:configurationAttributeType<boolean>,
  maxDiscountVisibility:configurationAttributeType<boolean>,
  suggestedQtyVisibility:configurationAttributeType<boolean>,
  pieceSizeVisibility:configurationAttributeType<boolean>,
  priceFormatter:configurationAttributeType<string>,
  cataloguePrioritySorting: configurationAttributeType<string>,
  tabFilterType: configurationAttributeType<string>,
  catalogueSequenceType: configurationAttributeType<string>,
  multiVariantOrder:configurationAttributeType<boolean>,
  outletLevelPricing: configurationAttributeType<boolean>,
  productTypeFilter: configurationAttributeType<string>,
  sspLabel: configurationAttributeType<string>,
  enableEditPrice: configurationAttributeType<boolean>,
  displayProductValidationFilter: configurationAttributeType<string>,
  displayProductValidation: configurationAttributeType<boolean>,
  defaultQtyForOrder: configurationAttributeType<string>,
  editPricing: configurationAttributeType<boolean>
    // skuCodeCondition:string,
    // favouriteSKU:boolean,

    // skuDescriptionFormatter:string,
    // skuCodeVisibility:boolean,
    // ptrLabel:string,
    // mrpLabel:string,
    // schemeLabel:string,
    // unitLabel:string,
    // unitVisibility:boolean,
    // autoUOMConversion:boolean,
    // multiUOMSelection:boolean,
    // packUnitLabel:string,
    // caseUnitLabel:string,
    // otherUnitLabel:string,
    // dummyProductImgUpload:string,
    // incentiveFlow:boolean,
    // showBilledSkuLabel:boolean,
    // displayPrice:boolean,
    // schemeVisibility:boolean,
    // additionalSchemes:boolean,
    // crossSellLabel:string,
    // upSellLabel:string,
    // orderUnit:string,
    // casePtrLabel:string,
    // packPtrLabel:string,
    // orderSuggestedQty:boolean,
    // defaultCatalogueImage:string|undefined,
    // missedSchemeVisibility:boolean,
    // catalogueSortingOrder:string[],
    // maxDiscountVisibility:boolean,
    // suggestedQtyVisibility:boolean
    // favouriteSKU:boolean,
    // newSkuTile:boolean,
    // NewProductSuggestedQtyTemplate:boolean,
    // currencySymbol:string,

}


export type filterLabelType ={
    [key: string]: configurationAttributeType<any>;
    pieceSizeLabelMapping:configurationAttributeType<any>,
}
export type appValueTypes ={
    [key: string]: configurationAttributeType<any>;
    appBuildType: configurationAttributeType<string>;
    iosAppId: configurationAttributeType<string>;
    appBuildId: configurationAttributeType<string>;
    androidAppId: configurationAttributeType<string>;
    clientLogo:configurationAttributeType<string>,
    poweredByLogo:configurationAttributeType<string>,
    loginBanner:configurationAttributeType<string>,
    clientHeaderLogo:configurationAttributeType<string>,
    appIcon:configurationAttributeType<string>,
    appName:configurationAttributeType<string>,
    isAppOffline:configurationAttributeType<boolean>,
    clientLogoHeight:configurationAttributeType<number>
    clientHeaderLogoHeight:configurationAttributeType<number>,
    appBarBackgroundType:configurationAttributeType<string>,
    solidAppBarColor:configurationAttributeType<string>,
    gradientAppBarColor:configurationAttributeType<string>,
    appbarBackgroundImage:configurationAttributeType<string>,
    loadingScreenText:configurationAttributeType<string>,
    loaderGIF:configurationAttributeType<string>,
    moengageKey:configurationAttributeType<string>,
    shareText:configurationAttributeType<string>,
    psLink:configurationAttributeType<string>,
    iosAppPackageName:configurationAttributeType<string>,
    appPackageName:configurationAttributeType<string>,
    deepLinkUrl:configurationAttributeType<string>,
    loadingBackgroundImage:configurationAttributeType<string>,
    privacyPolicyValidation:configurationAttributeType<boolean>,
    isSuggestProductToBeShown:configurationAttributeType<boolean>,
    slackAlertChannel:configurationAttributeType<string>,

}

export type homepageValueTypes =[]
export type sqlAceEditorProps={
    query: string,
    theme: string,
    readonly: boolean
}

export type metadataRequestBodyForFinagg = {
  role: string,
  paymentProvideType: string
}

export type profileRequestBodyForFinagg = {
  name: string,
  type: string,
  attributes: Attributes;
}

export type Attributes = {
  salt: string,
  PublicKey: string,
  PrivateKey: string,
  AESAlogrithm: string,
  RSAAlogrithm: string
}

export type fileFormat = {
  fileFormat: string;
  config: { [key: string]: any }
}

export type QueryFlag ={
    Warning: string[]
    "Not Allowed": string[]
  }

  export type columnsBodyObject = {
    id: string,
    data: string,
    colDisplayName: string
  }

  export type nodeType = {
    id: string,
    position: XYPosition,
    data: object,
    selected: boolean,
    type?: string
}

export type errorCodesObjectArray = {
  errorCodesObjectArray : errorCodesObject[];
}

export type errorCodesObject = {
  key2: string,
  key3: string,
  key5: string,
  key4: string
} 
export type bulkInvoiceRowsData = {
  [key:string] : any
  id:string
  outletName: string,
  outletCode: string,
  creationTime: string,
  totalCaseQuantity: string,
  totalPieceQuantity: string,
  totalOtherUnitQuantity: string,
  netAmount: string,
  status: string,
  orderNumber: string,
  orderId: string,
  refNo?:string
}
export type bulkConfirmRowsData = {
  [key:string] : any
  id:string
  outletName: string,
  outletCode: string,
  creationTime: string,
  totalCaseQuantity: string,
  totalPieceQuantity: string,
  totalOtherUnitQuantity: string,
  netAmount: string,
  status: string,
  orderNumber: string,
}
export type manageOrderRowsData = {
  [key:string] : any
  id:string
  outletName: string,
  outletCode: string,
  creationTime: string,
  totalCaseQuantity: string,
  totalPieceQuantity: string,
  totalOtherUnitQuantity: string,
  netAmount: string,
  status: string,
  orderNumber: string,
  checkOrderStatus: boolean
  eInvoiced: boolean
  cancelledInvoice: boolean
  orderDetails?: [],
  invoiceNumber?:string,
  refNo?:string
}

export type managePrimaryOMSOrderRowsData = {
  [key:string] : any
  id:string
  outletName: string,
  outletCode: string,
  creationTime: string,
  totalCaseQuantity: string,
  totalPieceQuantity: string,
  totalOtherUnitQuantity: string,
  netAmount: string,
  status: string,
  orderNumber: string,
  checkOrderStatus: boolean
  eInvoiced: boolean
  cancelledInvoice: boolean
  orderDetails?: []
  siteId?: string
}
export type manageInvoiceRowsData = {
  [key:string] : any
  id:string
  outletName: string,
  outletCode: string,
  creationTime: string,
  totalCaseQuantity: string,
  totalPieceQuantity: string,
  totalOtherUnitQuantity: string,
  netAmount: string,
  status: string,
  invoiceNumber: string,
  orderNumber: string,
  checkOrderStatus: boolean,
  eInvoiced: boolean,
  editIcon: boolean,
  downloadId:string,
}
export type manageEntityApprovalRowsData = {
  [key:string] : any
  referenceId:string
  id: string,
  creationTime: string,
  status: string
}

export interface ReportFilter {
  key: string;
  value: string;
}

export type loadoutsData = {
  id: string;
  downloadId: string;
  loadNumber: string;
  type: string;
  routeId: string;
  vehicleId: string;
  loadOutDate: string;
  salesRepName: string;
  salesmanId: string;
  supplier: string;
  deliveryStartDate: string;
  deliveryEndDate: string;
  invoiceCreationStartDate: string;
  invoiceCreationEndDate: string;
  loadOutDetails: any[];
  loadoutSource: string;
  totalAmount: number;
  totalCaseQty: number;
  totalPieceQty: number;
  totalOtherQty: number;
  totalSoldCaseQuantity?: number;
  totalSoldPieceQuantity?: number;
  totalSoldOtherQuantity?: number;
  totalCaseLeftQty: number;
  totalPieceLeftQty: number;
  totalOtherLeftQty: number;
  status: "PENDING" | "IN-TRANSIT" | "DELIVERED" | "CANCELLED" | "IN-DRAFT";
  showEyeIcon: boolean;
  showDeleteIcon: boolean;
};

export type orderInfoTileProps = {
  heading: string,
  row: string[];
}

export type navigateType= {
  row: manageOrderRowsData;
}

export type navigateApprovalType= {
  row: manageEntityApprovalRowsData;
}

export type viewOrderRowsData = {
  id?:string,
  sku: string,
  category: string,
  subCategory:string,
  price: string,
  caseQty: string,
  packQty: string,
  amount: string
}

export type userDetailsRowsData = {
  id:string,
  checkLeafURL: string,
  authorizationLetter: string
}


export type RecipientListType = {
  to: string,
  cc: string,
  bcc: string,
  subject?: string,
  message?: string,
  id?: string
}

export type DateFilterType = {
  startDateForAttribute: string,
  endDateForAttribute: string,
  isInitialised: boolean
}

export type couponRowsData = {
  discountId: string,
  schemeDescription: string,
  startDate: string,
  endDate: string,
  type: string,
  id: string,
  discountName: string,
  creteria: string,
  discounted_amount: string,
  start_amount: string,
  end_amount: string,
  openModal: boolean,
  setOpenModal: React.Dispatch<React.SetStateAction<boolean>>,
  isUpdated: boolean,
  setIsUpdated: React.Dispatch<React.SetStateAction<boolean>>
}

export type updateCouponInfoBody = {
  discountId: string,
  endDate: string
}

export interface ConfigComparePopupProps {
  newConfig: any,
  curConfig: any,
  showConfigPopup: boolean,
  setShowConfigPopup: React.Dispatch<React.SetStateAction<boolean>>,
  message: string,
  // onSuccess: () => void | Promise<boolean>
  onSuccess: () => Promise<void>
  onCancel?: () => void
}
export interface validateAPIStateType {
  apiResponses: Record<string | number, any>;
  token: string
  validationStatus: Record<string | number, "success" | "failure" | "inProgress">;
  APIState: Record<string , "fetching" | "cache"| "">
  // cache means redux store
}

export interface validateAPIPayloadType {
  data: any;
  token?: string;
  id?:string;
}

export type paymentBlock = {
  loginId: string;
  type: string;
  active: string;
}
export type loginData = {
  loginId: string;
  password: string;
  lob?: string;
  deviceId?: string;
  secureToken?: string;
  unlimitedExpiry?: boolean;
}

export type Region = {
  code: string;
  holidays: string[];
}
export interface metaDataBatchPayload {
  features: updateConfigRequestBody[]
}

export interface CalenderFilterType {
  ordersData: null;
  setOrdersData: React.Dispatch<React.SetStateAction<null>>;
  loginId: string;
  id: string | undefined;
  anchorEl: HTMLButtonElement | null;
  setAnchorEl: React.Dispatch<React.SetStateAction<HTMLButtonElement | null>>;
  open: boolean;
}

export interface ListDropdownType{
  listData: string[] | null;
  id: string | undefined;
  anchorEl: HTMLButtonElement | null;
  setAnchorEl: React.Dispatch<React.SetStateAction<HTMLButtonElement | null>>;
  open: boolean;
  onSelect: (code: string) => Promise<void>
}
export interface EditGrnLocationState {
  orderData: any;
  invoiceDetails: any;
  deliveryData: any;
  totalFooterValue: any;
  outletCode: any;
  currencySymbol: string;
}

export type primaryOrderRowsData = {
  [key: string]: any;
  id: string;
  orderNumber: string;
  invoiceNumber ? : string;
  creationTime: string;
  totalCaseQuantity: string;
  totalPieceQuantity: string;
  netAmount: string;
  status: string;
  showEyeIcon: boolean;
  hideGRNStatusPendingOrder?: boolean;
};

export interface grnRowsData extends primaryOrderRowsData {
  grnStatus: string;
  redirectViewGRNicon?:boolean;
  totalInitialCaseQuantity :number;
  totalInitialPieceQuantity :number;
  totalInitialOtherQuantity :number;
}

export type viewPrimaryOrderRowsData = {
  id ? : string;
  skuCode: string;
  source?: string;
  batchCode?: string;
  skuDescription: string;
  category: string;
  pricePerCase: string;
  totalCaseQuantity: string;
  actualAmount: string;
  discount: string;
  taxInfo:any,
  caseQuantity: number,
  pieceQuantity: number,
  otherUnitQuantity: number,
  actualCaseQuantity: number;
  actualPieceQuantity: number;
  actualOtherUnitQuantity: number;
  finalAmount: string;
  collapsed?: boolean;
  freeItem?: boolean;
  uom?: string;
  caseToPieceQty?: number;
  otherToPieceQty?: number
  casePrice?: string,
  price?: string,
  otherUnitPrice?: string,
};

export interface editGrnRowsData  {
  id ? : string;
  skuCode: string;
  type: string;
  batchCode?: string;
  batchId?: string;
  skuDescription: string;
  category: string;
  pricePerCase: string;
  actualAmount: string;
  discount: number;
  initialCaseQuantity:number,
  initialPieceQuantity:number,
  initialOtherUnitQuantity:number,
  taxInfo:any;
  finalAmount: string;
  collapsed?: boolean;
  accpeptedQtyObj: {
      acceptedQty: number;
      totalQty: number;
  };
  rejectedQtyObj: {
      rejectedQty: number;
      totalQty: number;
  };

  accpeptedOtherQtyObj: {
    acceptedQty: number;
    totalQty: number;
  };
  rejectedOtherQtyObj: {
    rejectedQty: number;
    totalQty: number;
  };
  accpeptedPieceQtyObj: {
    acceptedQty: number;
    totalQty: number;
  };
  rejectedPieceQtyObj: {
    rejectedQty: number;
    totalQty: number;
  };
  skuRejectionReason:string;
    rejectedCaseQuantity: number;
    rejectedPieceQuantity:number;
    rejectedOtherUnitQuantity: number;
    qtyCase:number;
    qtyPiece:number;
    qtyOtherUnit:number;
    piecePrice:number;
}

export interface GenericPopUpProps {
  type: popupType;
  message: string;
  openGenericModal: boolean;
  setOpenGenericModal: React.Dispatch < React.SetStateAction < boolean >> ;
  dropdownData ? : string[];
  setDropdownSelectedValue ? : React.Dispatch < React.SetStateAction < string >> ;
}

export type BatchAndExpiryManagementRowsData = {
  id: string;
  adjustmentDate: string;
  skuCode: string;
  skuDescription: string;
  batchId: string;
  pieceCommittedQty: number;
  pieceAvailableQty: number;
  pieceUnsellableQty: number;
  pieceReturnedQty: number;
  pieceInTransitQty: number;
  pieceOnRouteQty: number;
  caseCommittedQty: number;
  caseAvailableQty: number;
  caseUnsellableQty: number;
  caseReturnedQty: number;
  caseInTransitQty: number;
  caseOnRouteQty: number;
  otherCommittedQty: number;
  otherAvailableQty: number;
  otherUnsellableQty: number;
  otherReturnedQty: number;
  otherInTransitQty: number;
  otherOnRouteQty: number;
  expiryDate: string;
  shelfLife: number;
};

export interface DeliveryInvoiceSkuDetails {
  id: string
  skuCode: string
  batchCode: string
  batchId: string
  skuName: string
  totalPieceQty: number
  totalCaseQty: number
  totalOtherQty: number
  soldPieceQty: number
  soldCaseQty: number
  soldOtherQty: number
  returnPieceQty: number
  returnCaseQty: number
  returnOtherQty: number
  ptr: number
  returnAmount: number
  batchIds: DeliveryInvoiceBatchDetails[]
  extendedAttributes:any
  otherUnitName?:string | undefined
}

export interface ReturnDetailsObject{
  returnId:string
  returnAmount:number
  outletCode:string
}

export interface DeliveryInvoiceBatchDetails {
  expiryDate?: string;
  packPtr?: number;
  mrp?: number;
  batchId: string
  caseQty: number
  otherQty: number
  pieceQty: number
  reasonDetails?: SalesReasonDetails[]
  otherUnitName?: string | undefined
}

export interface SalesReasonDetails {
  reason:string
  saleCondition?:string
  caseQty:number
  pieceQty:number
  otherQty:number
}

export interface ManualStockSkuDetail {
  batchId: string;
  currentPieceBatchQty: number;
  updatedPieceBatchQty: number;
  currentCaseBatchQty: number;
  updatedCaseBatchQty: number;
  currentOtherBatchQty: number;
  updatedOtherBatchQty: number;
  reasonForAdjustment: string;
  individualStatus: string;
  otherUnitName?: string;
}

export interface ManualStockAdjustmentRowsData {
  id: string;
  requestId: string;
  skuDescription:string;
  skuCode: string;
  stockType: string;
  currentPieceStockQty: number;
  updatedPieceStockQty: number;
  currentCaseStockQty: number;
  updatedCaseStockQty: number;
  currentOtherStockQty: number;
  updatedOtherStockQty: number;
  adjustmentDate: string;
  status: string;
  expiryDate:string;
  skuDetails: ManualStockSkuDetail[];
  batchIdCount:number;
  otherUnitName?: string;
}

export type AuditTrailsRowsData = {
  id: string;
  timestamp: string;
  transactionType: string;
  skuCode: string;
  skuName?: string;
  caseQty: number;
  pieceQty: number;
  otherQty: number
  status: string;
  currentCaseQty: number;
  currentPieceQty: number;
  currentOtherQty: number;
  stockTypeFrom: string;
  stockTypeTo: string;
  userId: string;
  transactionId: string;
  batchId: string;
  revertType: string;
};

export type RealTimeStockRowsData = {
  id: string;
  creationTime: string;
  lastModifiedTime: string;
  skuCode: string;
  skuDescription: string;
  brand: string;
  category: string;
  shelfLife:number;
  otherUnitName?: string | undefined;
  pieceCommittedQty: number;
  pieceAvailableQty: number;
  pieceUnsellableQty: number;
  pieceReturnedQty: number;
  pieceInTransitQty: number;
  pieceOnRouteQty: number;
  caseCommittedQty: number;
  caseAvailableQty: number;
  caseUnsellableQty: number;
  caseReturnedQty: number;
  caseInTransitQty: number;
  caseOnRouteQty: number;
  otherCommittedQty: number;
  otherAvailableQty: number;
  otherUnsellableQty: number;
  otherReturnedQty: number;
  otherInTransitQty: number;
  otherOnRouteQty: number;
};

export interface StockTypeUpdateSkuDetail {
  batchId: string;
  pieceQty: number;
  caseQty: number;
  otherQty: number;
  reason: string;
  toStatus: string;
}

export type StockTypeUpdateRowsData = {
  id: string;
  requestId: string;
  adjustmentDate: string;
  skuCode: string;
  skuDescription:string;
  skuName: string;
  fromStatus: string;
  updatedPieceQuantity:string;
  updatedCaseQuantity:string;
  updatedOtherQuantity:string;
  batchIdCount:number 
  skuDetails: StockTypeUpdateSkuDetail[];
  otherUnitName?: string | undefined;
}

export type ColumnMetaData < T > = {
  headerName: string;
  mappedValue: keyof T;
  width: number;
  headerAlign: string;
  align: string;
  paddingLeft?: string;
  paddingRight?: string;
  truncateTextAfterLine?: number;

};
export interface BatchWiseStockApiResponse {
  skuCode: string;
  batchId: string;
  committedQty: number;
  availableQty: number;
  unsellableQty: number;
  inTransitQty: number;
  onRouteQty: number;
  returnedQty: number;
  expiryDate: string;
  lastModifiedTime: string;
  quantityType: "otherQty" | "pieceQty" | "caseQty";
}
export interface RealTimeStockApiResponse {
  type: string;
  skuCode: string;
  committedQty: number;
  availableQty: number;
  unsellableQty: number;
  inTransitQty: number;
  onRouteQty: number;
  returnedQty: number;
  lastModifiedTime: string;
  quantityType: "otherQty" | "pieceQty" | "caseQty";
}


export interface TransformedBatch {
  id:string;
  batchId: string;
  skuCode: string;
  otherQty?: QuantityDetail;
  pieceQty?: QuantityDetail;
  caseQty?: QuantityDetail;
}
export interface TransformedRealTimeStock {
  id:string;
  skuCode: string;
  type: string;
  otherQty?: QuantityDetail;
  pieceQty?: QuantityDetail;
  caseQty?: QuantityDetail;
}

export interface QuantityDetail {
  committedQty: number;
  availableQty: number;
  unsellableQty: number;
  inTransitQty: number;
  onRouteQty: number;
  returnedQty: number;
  expiryDate?: string;
  lastModifiedTime: string;
}

export interface StockOrder  {
  [skuCode: string]: {
    availableCaseQty: number;
    availablePieceQty: number;
    availableOtherQty: number;
  };
};

export enum OrderType {
  PRIMARY = "Primary",
  SECONDARY = "Secondary",
}

export interface DownloadSingleReportConfig {
  reportId: string;
  filters: ReportFilter[];
}

export type invoiceDeliveryStatusConfig = {
  id:string;
  dmsLabelColor?: string;
  dmsLabel?: string;
  dmsColor?: string;
}
export interface DeliveryInvoiceDetailType {
  invoiceNumber: string;
  source: string
  loginId: string
  status: string;
  loadNumber: string;
  deliveryDate: string;
  modeOfDelivery: string;
  outletName: string;
  outletCode: string;
  skuCount: number;
  amount: number | string; 
  taxAmount: number | string;
  discountAmount: number | string;
  finalAmount: number | string;
  gstApplicable: boolean;
  isEInvoiced:boolean;
  hasGstin: boolean;
  salesInfo: any;
  outletNameCode: string
  extendedAttributes: any
}

export interface InvoiceDetailsCardProps{
  invoiceDetails: DeliveryInvoiceDetailType;
  invoiceReturnAmount: number | string;
  deliveryStatus: string | null
  isPartialDeliveryAllowed: boolean
  isExpanded: boolean
  setIsExpanded: React.Dispatch<React.SetStateAction<boolean>>
}

export interface QtyData {
  cs: number;
  pc: number;
}

export interface UomConversionResult {
  convertedCaseQty: number;
  convertedOtherQty: number;
  convertedPieceQty: number;
  hasQtyExceededStock?: boolean;
}

export interface MultiQuantities {
  caseQuantity: number;
  otherUnitQuantity: number;
  pieceQuantity: number;
}


export interface LoadoutDetailsType {
  showEyeIcon: boolean
  loadNumber: string
  loadoutSource: string
  vehicleId: any
  salesmanId: string
  salesmanName: string
  supplier: string
  status: string
  type: string
  vehicleCapacity: any
  totalAmount: number
  totalCaseQty: number
  totalPieceQty: number
  totalOtherQty: number
  totalCaseLeftQty: number
  totalPieceLeftQty: number
  totalOtherLeftQty: number
  soldCaseQty: number
  soldPieceQty: number
  soldOtherQty: number
  pieceShortage: number
  caseShortage: number
  otherShortage: number
  actualPieceReturnedQty: number
  actualCaseReturnedQty: number
  actualOtherReturnedQty: number
  isActualQtyEditable:boolean
  isActualQtyDisabled:boolean
  loadOutDetails: LoadOutDetail[]
  loadOutDate: string
  settlementDate:string
  deliveryStartDate:string
  deliveryEndDate:string
  invoiceCreationStartDate:string
  invoiceCreationEndDate:string
  shortageUpdated:boolean
  redirectIcon: string
}

export interface LoadOutDetail {
  id:string
  isEInvoiced:boolean
  loadNumber: string
  invoiceNumber: string
  routeCode: string
  outletCode: string
  presellerId: string
  status: string
  totalAmount: number
  totalCaseQty: number
  totalPieceQty: number
  totalOtherQty: number
  totalCaseLeftQty: number
  totalPieceLeftQty: number
  totalOtherLeftQty: number
  soldCaseQty: number
  soldPieceQty: number
  soldOtherQty: number
  salesInfo: SalesInfo
  salesmanId?:string
  deliveryDate: string
  outletName:string
  gstApplicable:boolean
  skuCount: number
  taxAmount: number
  discountAmount:number
  finalAmount:number
  modeOfDelivery: string
  invoiceStatus: string
  loadOutItems: LoadOutItem[]
  redirectIcon?: string
  invoiceDraftStatus?: string
}

export interface SalesReturnDetail {
  id : string
  returnNumber : string
  invoiceNumber : string
  invoiceNumberToDisplay: string
  loadoutNumber : string
  deliveryRoute : string
  deliveryDate : string
  returnDate : string
  vehicleNumber : string
  outletName : string
  outletCode: string
  soldCaseQty : number
  soldPieceQty : number
  soldOtherQty : number
  returnCaseQty : number
  returnPieceQty : number
  returnOtherQty : number
  returnAmount : number
  status : string
  saleCondition : string
  source : string
  supplier:string
  keyAccount : boolean
  otherUnitName?: string | undefined
  routeCode: string
  routeName: string
  salesRepId: string
  salesRepName: string
}

export interface SalesInfo {
  gstAmount: number
  tcsAmount: number
  discountAmount: number
  finalAmount: number
  invoiceStatus: string
}

export interface LoadOutItem {
  loadOutDetailsId: string
  skuCode: string
  mrp: number
  batchCode: string
  batchId: string
  caseQty: number
  pieceQty: number
  otherQty: number
  caseQtyLeft: number
  pieceQtyLeft: number
  otherQtyLeft: number
  amount: number
  itemType: string
}
export interface DeliveryInvoiceSummary {
  total: number;
  pending: number;
  delivered: number;
  partiallyDelivered: number;
  cancelled: number;
}

export interface SaleReturnSummary {
  totalOutlets : number
  totalReturnCaseQty : number
  totalReturnPieceQty : number
  totalReturnOtherQty : number
  totalReturnAmount : number
}

export interface StatusFilterMenuItems {
  id:string
  label: string
}


export interface ReturnableInvoiceDetails{
  invoiceNumber: string
  outletCode:string
  outletName:string
  deliveryDate:string
  creationTime?:string
  salesMan?: string
  salesManName?: string
  routeId?: string
  beatName?: string
}

export interface CreateSaleReturnFormData {
    outletCode: string;
    outletName: string;
    invoiceNumber: string;
    deliveryDate: string;
    creationTime?: string;
    salesMan: string;
    salesManName?: string;
    RouteIdAndName?: string;
}

export interface Invoice {
  createdBy: string
  modifiedBy: string
  creationTime: string
  lastModifiedTime: string
  lob: string
  id: string
  activeStatus: string
  activeStatusReason: any
  version: number
  source: string
  changes: any[]
  changed: boolean
  extendedAttributes: InvoiceExtendedAttributes
  systemTime: string
  gpsLatitude: any
  gpsLongitude: any
  orderNumber: string
  initialAmount: number
  netAmount: number
  saleCondition: string
  billAmount: number
  returnAmount: number
  returnNumber:string
  mrp: number
  name: any
  status: string
  type: string
  size: any
  program: any
  remarks: string
  validate: boolean
  update: boolean
  supplierHierarchy: string
  supplier: string
  locationHierarchy: string
  payByDate: any
  orderedDate: any
  normalizedVolume: number
  loginId: string
  outletCode: string
  outletName: string
  accountType: string
  invoiceNumber: string
  referenceNumber: any
  statusReason: any
  totalQuantity: number
  totalInitialQuantity: number
  normalizedQuantity: number
  initialNormalizedQuantity: number
  userExists: boolean
  outletExists: boolean
  salesDetails: SalesDetail[]
  discountInfo: InvoiceDiscountInfo[]
  salesHistory: any[]
  beat: any
  beatName: any
  create: boolean
  loadoutNumber:string
  deliveryMode:string
  vehicleNumber:string
  returnDate:string
  totalProducts:string
}
export interface updatedInvoice {
  createdBy: string
  modifiedBy: string
  creationTime: string
  lastModifiedTime: string
  lob: string
  id: string
  activeStatus: string
  activeStatusReason: any
  version: number
  source: string
  changes: any[]
  changed: boolean
  extendedAttributes: InvoiceExtendedAttributes
  systemTime: string
  gpsLatitude: any
  gpsLongitude: any
  orderNumber: string
  initialAmount: number
  netAmount: number
  billAmount: number
  returnAmount: number
  returnNumber:string
  mrp: number
  name: any
  status: string
  type: string
  size: any
  program: any
  remarks: string
  validate: boolean
  update: boolean
  supplierHierarchy: string
  supplier: string
  locationHierarchy: string
  payByDate: any
  orderedDate: any
  normalizedVolume: number
  loginId: string
  outletCode: string
  outletName: string
  accountType: string
  invoiceNumber: string
  referenceNumber: any
  statusReason: any
  totalQuantity: number
  totalInitialQuantity: number
  normalizedQuantity: number
  initialNormalizedQuantity: number
  userExists: boolean
  outletExists: boolean
  salesDetails: SalesDetail[]
  discountInfo: InvoiceDiscountInfo[]
  salesHistory: any[]
  beat: any
  beatName: any
  create: boolean
  loadoutNumber:string
  deliveryMode:string
  vehicleNumber:string
  returnDate:string
  totalProducts:string
  deliveryRoute: string
  deliveryDate: string
  soldCaseQty: number
  soldPieceQty: number
  soldOtherQty: number
  returnCaseQty: number
  returnPieceQty: number
  returnOtherQty: number
  keyAccount: boolean
}

export interface InvoiceExtendedAttributes {
  billTo?: BillTo
  shipTo?: ShipTo
  IRNDtls?: string
  postProcess?: string
  billingAddress?: string
  shippingAddress?: string
}

export interface BillTo {
  city: string
  state: string
  address: string
  country: string
  pincode: string
  contactNo: string
  stateCode?: string
  contactName?: string
}

export interface ShipTo {
  city: string
  state: string
  address: string
  country: string
  pincode: string
  contactNo: string
  contactName?: string
  stateCode?: string
}

export interface SalesDetail {
  createdBy: string
  modifiedBy: string
  batchIdCount:number
  packType: string
  creationTime: string
  lastModifiedTime: string
  lob: string
  id: string
  activeStatus: string
  activeStatusReason: any
  version: number
  source: any
  changes: any[]
  changed: boolean
  extendedAttributes: SalesDetailsExtendedAttributes
  systemTime: string
  gpsLatitude: any
  gpsLongitude: any
  orderNumber: string
  initialAmount: number
  netAmount: number
  billAmount: number
  mrp: number
  name: any
  status: string
  type: string
  size: any
  program: any
  remarks: any
  validate: boolean
  update: boolean
  supplierHierarchy: string
  supplier: string
  locationHierarchy: string
  payByDate: any
  orderedDate: any
  normalizedVolume: number
  batchCode: string
  batchIds?: SalesBatchId[]
  batchIdDetails?: SalesBatchIdDetails[]
  skuCode: string
  skuName: string
  invoiceNumber: string
  productDetails: any
  price: number
  pieceQuantity: number
  otherUnitQuantity: number
  initialQuantity: number
  initialPieceQuantity: number
  initialCaseQuantity: number
  initialOtherUnitQuantity: number
  caseQuantity: number
  quantityUnit: any
  normalizedQuantity: number
  otherUnitPrice: number
  casePrice: number
  initialNormalizedQuantity: number
  productInfo: SaleProductInfo
  discountInfo: any
  discountPercentage: number
  create: boolean
  soldCaseQty: number
  soldPieceQty: number
  soldOtherQty: number
  returnCaseQty: number
  returnPieceQty: number
  returnOtherQty: number
  totalPieceQty: number
  totalCaseQty: number
  totalOtherQty: number
}

export interface ReturnSkuDetail {
  id: string
  skuCode: string
  batchCode: string
  skuName: string
  packType: string
  ptr: number
  pieceQuantity: number
  otherUnitQuantity: number
  caseQuantity: number
  batchIds: {[key: string]: SalesReasonDetails[]}
  batchIdCount: number
}

export interface SalesDetailsExtendedAttributes {
  mrp: number
  taxInfo: SalesDetailsTaxInfo[]
  postProcess?: string
  increasedAmount?: number
  increasedQuantity?: number
}

export interface SalesDetailsTaxInfo {
  skuCode: string
  taxType: string
  taxAmount: number
  taxPercent: string
}

export interface SalesBatchId {
  batchId: string
  caseQty: number
  otherQty: number
  pieceQty: number
  reasonDetails?: SalesReasonDetails[]
}

export interface SalesBatchIdDetails extends SalesReasonDetails{
  batchId: string
  mrp: number
}

export interface SaleProductInfo {
  category: string
  subCategory: string
  skuDescription: string
  otherUnitToPieceQuantity: number
}

export interface InvoiceDiscountInfo {
  sb: boolean
  minSlab: number
  discount: string
  schemeUsed: boolean
  finalAmount: string
  actualAmount: string
  discountType: string
  showSchemeDescription: boolean
  bu?: boolean
}

export interface BatchDetailsMap{
  [key: string]: {[key: string]: SalesReasonDetails[]}
}

export interface DetailsBoxDivision{
    components:DetailsBoxComponents[]
}
export interface DetailsBoxComponents{
    label:string
    value:any
}

export type TableViewerProps = {
  selectedOption: string;
  onExecuteChanges: (changes: any, approver:string, context: string) => void;
  onDeleteRecord: (id: string, record: any, tableName:string, approver:string, context:string) => void;
  onInsertRecord: (record: any,tableName:string, approver:string, context: string) => void;
  userEmail: string;
  selectedOptionApprover: string;
}

export type QueryInputProps = {
  selectedOption: string;
  userEmail: string;
  selectedOptionApprover: string;
}

export type TableData = {
  data: Record<string, any>[];
  total: number;
}

export type PendingChange = {
  operation: "UPDATE" | "DELETE" | "INSERT";
  tableName: string;
  id: string;
  changes: Array<{
    key: string;
    oldValue: any;
    newValue: any;
  }>;
}

export type Change = {
  id: string;
  direction: string;
  query: { forward: string; reverse: string };
}
// export type GoogleTokenResponse = {
//     success: boolean;
//     token?: string;
//     email?: string;
//     error?: string;
//   }
export interface QtyDisplayColorScheme {
  background:string
  label:string
  value:string
}

export enum FilterKeys{
  PRIMARY_ViewAllGrn = "viewAllGrnFilter",
  PRIMARY_ViewPrimaryOrders = "viewPrimaryOrdersFilter",
  SECONDARY_ManageOrders = "manageOrdersFilter",
  SECONDARY_ManageInvoices = "manageInvoicesFilter",
}


export interface OutletCollectionDetails {
    outletCode: string
    outletName: string
    outletType: string
    creditLimit: number
    creditNoteAmount: number
    balanceAmount: number
    status: string
    redirectIcon: string
    gstApplicable: boolean
    creditDueDate?: string; 
    creditStatus: string 
}
export interface TaxDetails {
  taxType: string
  taxMap: TaxMap
  sameLocation: boolean
  warehouseCheck: boolean
}

export interface TaxMap {
  [key:string]: TaxInfo[]
}

export interface TaxInfo {
  createdBy: string
  modifiedBy: string
  creationTime: string
  lastModifiedTime: string
  lob: string
  id: string
  activeStatus: string
  version: number
  changes: any[]
  changed: boolean
  batchCode: string
  skuCode: string
  taxRate: number
  taxType: string
  priority: number
  create: boolean
}

export type ManageOutletApprovalRowData = {
  [key: string]: any;
  id: string;
  outletName: string,
  outletCode: string,
  salesRepName: string,
  uniqueSalesRepId: string,
  distributorName: string,
  distributorId: string,
  outletCity:string,
  outletMobileNumber: string,
  outletPincode: string,
  outletSource: string,
  status: string;
  showEyeIcon: boolean;
};

export type ViewOutletDetailsData = {
  keyAccount: string | null;
  activeStatus: string | null;
  outletName: string | null;
  outletCode: string | null;
  outletChannel: string | null;
  outletClass: string | null;
  outletAddress: string | null;
  outletCity: string | null;
  outletPincode: string | null;
  outletContact: string | null;
  outletEmail: string | null;
  distributorCode: string | null;
  paymentMode: string | null;
  discountPercentage: string | null;
  cashDiscount: string | null;
  loyaltyBalance: string | null;
  walletBalance: string | null;
  salesRepCode: string | null;
  outletLatitude: number | null;
  outletLongitude: number | null;
  outletCreateDate: string | null;
  outletAccountNo: string | null;
  outletType: string | null;
  outletSubChannel: string | null;
  outletPriceGroup: string | number | null;
  shipToCity: string | null;
  shipToState: string | null;
  shipToAddress: string | null;
  shipToPincode: string | null;
  shipToContact: string | null;
  shipToContactPersonName: string | null;
  shipToDescription: string | null;
  creditLimit?: string | null;
  creditDays?: string | null;
  bank?: string | null;
  ifsc?: string | null;
  outletGstin?: string | null;
  outletPan?: string | null;
  shiptoGSTIN?: string | null;
  outletRoute?: string | null;
  outletCategory?: string | null;
  salesRepName?: string | null;
  supplierName?: string | null;
  imageUrl?: string | null
};


export interface OutletLedgerResult {
  id: string | number;
  outletCode: string;
  loginId: string;
  referenceNumber: string;
  creditStatus: string;
  status: string;
  creditLimit: number;
  creditAvailable: number;
  creditAmount: number;
  creditExpiry: string;
  creditDueDate: string;
  lastModifiedTime: string;
  amountLastReceived: string | number;
  totalDueDays: number;
  createdOn: string;
  outletName: string;
  outletType: string;
  gstApplicable: boolean;
  redirectIcon: string;
}

export interface OutletLedgerData {
  id: string;
  outletCode: string;
  creditAmount: number;
  createdOn: string;
  outletName: string;
  redirectIcon: string;
  lastBilledDate: string
  lastPaymentDate: string
}


export interface OutletLedgerTransaction {
  documentDate: string;
  documentId: string;
  description: string;
  particular: string;
  debitAmount: number;
  creditAmount: string;
}

export type SalesReturnBatchId= {
  batchId: string;
  caseQty: number;
  otherQty: number;
  pieceQty: number;
  reasonDetails?: SalesReturnBatchId[];
};


export type SalesBatchDetail = {
  batchCode: string;
  batchIds?: SalesReturnBatchId[];
};

export interface Feature{
  salesDetails?: SalesDetail[];
};

export type BatchSummary = {
  [batchCode: string]: {
    caseQty: number;
    pieceQty: number;
    otherQty: number;
  };
};

export type QtyBatchObject = {
  skuCode: string;
  batchIdcaseQty?: number;
  batchIdpieceQty?: number;
  batchIdotherQty?: number;
};


export interface ProductInfo {
  name?: string;
  description?: string;
  [key: string]: any;
}

export interface ProductDetails {
  [skuCode: string]: ProductInfo;
}

export interface ReasonDetail {
  saleCondition: "Saleable" | "Unsaleable";
  pieceQty: number;
  caseQty: number;
  otherQty: number;
}

export interface BatchDetail {
  batchId: string;
  reasonDetails: ReasonDetail[];
}

export interface BatchIds {
  batchId: string;
  caseQty?: number;
  otherQty?: number;
  pieceQty?: number;
  reasonDetails?: SalesReasonDetails[];
}

export interface TransformedSalesDetail {
  supplier: string;
  extendedAttributes: {
    saleCondition: "Saleable" | "Unsaleable";
  };
  skuCode: string;
  productInfo?: ProductInfo;
  batchCode: string;
  price: number;
  saleCondition: "Saleable" | "Unsaleable";
  pieceQuantity?: number;
  caseQuantity?: number;
  otherUnitQuantity?: number;
  batchId: string;
  batchIds: BatchIds; 
}

export interface SimpleSalesDetail {
  supplier: string;
  skuCode: string;
  productInfo?: ProductInfo;
  batchCode: string;
  price: number;
  pieceQuantity: number;
  caseQuantity: number;
  otherUnitQuantity: number;
  batchIds: BatchIds[]; 
}

export interface ReturnSkuDetail {
  skuCode: string;
  batchCode: string;
  ptr: number;
  pieceQuantity: number;
  caseQuantity: number;
  otherUnitQuantity: number;
  batchIds: { [key: string]: SalesReasonDetails[]; }
}

export interface ConfigDictionary {
  salesReturnReasonsMap?: { [key: string]: string[] };
  batchIdConfiguration?: boolean;
}

export interface ReturnBatchDetails {
  referenceNumber: string,
  netNormalizedQty: number,
  skuDetailsSummary: any,
  batchDetails: any,
  returnDetails: SalesReturnDetail[]
}

export type RouteInfo = {
  createdBy: string;
  modifiedBy: string;
  creationTime: string;
  lastModifiedTime: string;
  lob: string;
  id: string;
  activeStatus: string;
  activeStatusReason: string | null;
  version: number;
  source: string | null;
  changes: any[];
  changed: boolean;
  extendedAttributes: any | null;
  entityId: string;
  entityCategory: string;
  parentId: string;
  entityType: string;
  key1: string | null;
  filter1: string | null;
  filter2: string | null;
  productInfo: any | null;
  date: string | null;
  create: boolean;
};
